export const HEADER_HEIGHT = 120;
export const HEADER_HEIGHT_MOBILE = 90;
export const SCENARIO_HEADER_HEIGHT = 96;
export const ADD_BUTTON_HEIGHT = 32;
